<template>
  <v-dialog v-model="dialog" width="960">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn large icon v-on="{ ...tooltip, ...dialog }">
            <v-icon>mdi-file-compare</v-icon>
          </v-btn>
        </template>
        <span>Compare Files</span>
      </v-tooltip>
    </template>

    <v-card raised class="pb-2">
      <v-toolbar flat dark color="primary">
        <v-toolbar-title>Compare</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-3 pb-2">
        <p v-if="loading">Loading Diff...</p>
        <vueCodeDiff
          v-if="newStr !== null && oldStr !== null"
          :new-string="newStr"
          :old-string="oldStr"
          outputFormat="line-by-line"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import APIService from "@/services/APIService.js";
import vueCodeDiff from "vue-code-diff";

export default {
  components: {
    vueCodeDiff
  },
  data() {
    return {
      dialog: false,
      loading: false,
      compare: null,
      oldStr: null,
      newStr: null
    };
  },
  watch: {
    dialog(status) {
      if (status) {
        this.loading = true;
        this.getCompare();
      } else {
        this.newStr = null;
        this.oldStr = null;
        this.loading = false;
      }
    }
  },
  methods: {
    getCompare() {
      return APIService.getCompare(this.$route.params.id)
        .then(response => {
          this.oldStr = response.data.old;
          this.newStr = response.data.new;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style></style>
